import { Component } from '@angular/core';

import { LocalizeComponent, UserComponent } from '../../../shared/components';

@Component({
  selector: 'app-title',
  imports: [UserComponent, LocalizeComponent],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {

}
